export default __webpack_public_path__ + "static/media/Ellipse36.1e68550e.svg";